import timesheet from "../timesheet";

const getters = {
    servicerequests: (state) => state.servicerequests,
    serviceOne: (state) => state.serviceOne,
    serviceOrderOne: (state) => state.serviceOrderOne,

    serviceOrderList: (state) => state.serviceOrderList,
    serviceOrder: (state) => state.serviceOrder,
    servicerequestDocuments: state => state.servicerequestDocuments,
    serviceOrderDocuments: state => state.serviceOrderDocuments,
    timesheetList: (state) => state.timesheetList,
    timesheet: (state) => state.timesheet,
    file: state => state.file,
    loading: state => state.loading,
    stafflistrequests: (state) => state.stafflistrequests,
};

export default getters;